import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { createElement } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * コンサルタント用にテキスト情報を表示するためのコンポーネント
 * @constructor
 */
export const RfpProfessionalOneDescriptionContent = ({ className = '', icon, text, title, }) => (_jsxs("div", Object.assign({ className: className }, { children: [_jsxs(IconTextGroup, Object.assign({ className: clsx('mb-8') }, { children: [createElement(icon, { className: 'flex', color: 'info', size: 'md' }), _jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'sm' }, { children: title }))] })), _jsx(Text, Object.assign({ className: 'whitespace-pre-line', color: 'base', size: 'sm', tagName: 'div' }, { children: text }))] })));
